import _regeneratorRuntime from "@babel/runtime/regenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { utils } from '@atlaskit/util-service-support';
import { version as npmPackageVersion } from './version.json';
export var DEFAULT_SOURCE = 'atlaskitNotificationLogClient';

var NotificationLogClient = /*#__PURE__*/function () {
  function NotificationLogClient(baseUrl, cloudId) {
    var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_SOURCE;

    _classCallCheck(this, NotificationLogClient);

    this.serviceConfig = {
      url: baseUrl
    };
    this.cloudId = cloudId;
    this.source = source;
  }

  _createClass(NotificationLogClient, [{
    key: "countUnseenNotifications",
    value: function () {
      var _countUnseenNotifications = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var options,
            mergedOptions,
            _args = arguments;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                mergedOptions = _objectSpread(_objectSpread({
                  path: options.useV3NotificationsApi ? '/api/3/notifications/count/unseen' : '/api/2/notifications/count/unseen'
                }, options), {}, {
                  queryParams: _objectSpread(_objectSpread({}, this.cloudId && {
                    cloudId: this.cloudId
                  }), {}, {
                    source: this.source
                  }, options.queryParams || {}),
                  requestInit: _objectSpread({
                    mode: 'cors',
                    headers: {
                      'x-app-version': "".concat(npmPackageVersion, "-").concat(DEFAULT_SOURCE)
                    }
                  }, options.requestInit || {})
                });
                return _context.abrupt("return", utils.requestService(this.serviceConfig, mergedOptions));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function countUnseenNotifications() {
        return _countUnseenNotifications.apply(this, arguments);
      }

      return countUnseenNotifications;
    }()
  }]);

  return NotificationLogClient;
}();

export { NotificationLogClient as default };